// Features/FAQ-Block/Component.ts
class FAQ_Block extends HTMLElement {
  listener = new AbortController;
  connectedCallback() {
    const { signal } = this.listener;
    this.part_question.addEventListener("click", this.onToggle.bind(this), { signal });
  }
  disconnectedCallback() {
    this.listener.abort();
  }
  onToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const question = this.part_question;
    const isOpen = question.classList.contains("active");
    for (const block of this.part_blocks) {
      if (block === this && !isOpen)
        block.openAnswer();
      else
        block.closeAnswer();
    }
  }
  closeAnswer() {
    const question = this.part_question;
    this.height = 0;
    question.classList.remove("active");
  }
  openAnswer() {
    const question = this.part_question;
    const answer = this.part_answer;
    this.height = answer.scrollHeight;
    question.classList.add("active");
  }
  set height(height) {
    this.part_answer.style.setProperty("---Height", `${height}px`);
  }
  get part_blocks() {
    return Array.from(this.parentElement.children);
  }
  get part_question() {
    return this.querySelector(`[ type = button ]`);
  }
  get part_answer() {
    return this.querySelector(`.FAQ_Answer`);
  }
}

// Features/FAQ-Block/mod.ts
customElements.define("faq-block", FAQ_Block);
